<template>
  <div class="person-card" @click="onOpen">
    <img class="person-avatar" src="@/assets/images/researchCamp/avatar.png" alt="">
    <div class="person-main">
      <div class="person-name-row">
        <div class="person-name-main">
          <span class="person-name">{{ item.name }}</span>
          <span class="person-level" v-if="item.level">{{ item.level }}</span>
        </div>
        <span class="person-top-badge" :class="{ 'is-score': !isDayBadge }" v-if="alignTop && item.badge">{{ item.badge }}</span>
      </div>
      <div class="person-line" v-if="item.center">{{ item.center }}</div>
      <div class="person-line">{{ item.hospital }} {{ item.department }} {{ item.title }}</div>
      <div class="person-line" v-if="item.joinDate">入营时间：{{ item.joinDate }}</div>
      <div class="person-line" v-if="item.extra">{{ item.extra }}</div>
    </div>
    <span class="person-badge" v-if="!alignTop && item.badge">{{ item.badge }}</span>
    <img class="person-arrow" v-if="arrow && !item.badge" src="@/assets/images/person/right.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'CampPersonCard',
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    },
    // 已完成列表
    alignTop: {
      type: Boolean,
      default: false
    },
    arrow: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    // 天数徽章和分数徽章样式不同
    isDayBadge () {
      return this.item.badge && String(this.item.badge).indexOf('天') >= 0
    }
  },
  methods: {
    // 只有展示箭头时才进入详情
    onOpen () {
      if (!this.arrow) return
      this.$emit('open')
    }
  }
}
</script>

<style lang="less" scoped>
@import '../camp.less';

.person-card {
  .camp-white-card();
  display: flex;
  align-items: flex-start;
  margin-top: 12px;
  padding: 16px 14px;
  border-radius: 8px;

  .person-avatar {
    width: 42px;
    height: 42px;
    margin-right: 10px;
    border-radius: 50%;
    object-fit: cover;
    overflow: hidden;
    flex-shrink: 0;
  }

  .person-main {
    flex: 1;
    min-width: 0;
  }

  .person-name-row {
    display: flex;
    align-items: flex-start;
    margin-bottom: 6px;
  }

  .person-name-main {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    flex: 1;
    min-width: 0;
    margin-top: 4px;
  }

  .person-name {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: @camp-text;
    word-break: break-all;
    margin-right: 6px;
  }

  .person-level {
    flex-shrink: 0;
    padding: 0 8px;
    border-radius: 18px;
    font-size: 11px;
    font-weight: 400;
    line-height: 18px;
    color: @camp-red;
    background: rgba(235, 23, 0, 0.08);
  }

  .person-line {
    font-size: 12px;
    line-height: 18px;
    color: @camp-sub;
    margin-top: 2px;
    word-break: break-all;
  }

  .person-arrow {
    width: 12px;
    margin-left: 8px;
    flex-shrink: 0;
    align-self: center;
  }

  .person-badge {
    margin-left: 8px;
    padding: 0 8px;
    height: 20px;
    line-height: 20px;
    border-radius: 10px;
    font-size: 12px;
    color: #fff;
    background: @camp-red;
    flex-shrink: 0;
  }

  .person-top-badge {
    width: 42px;
    height: 20px;
    margin-left: auto;
    padding: 0;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
    text-align: center;
    color: #fff;
    background: @camp-red;
    box-sizing: border-box;
    flex-shrink: 0;

    &.is-score {
      font-size: 14px;
      color: #fff;
      background: #FFA800;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/researchCamp/components/CampPersonCard.vue